import type { ChartHandler } from './handleClick.types';
import { getSelfKey } from '../check-if-selected/checkIfSelected';

export const handleClick: ChartHandler<MouseEvent> = (
  item,
  type,
  { selected, setSelected, event, grouping_key, ...props },
) => {
  event?.preventDefault();

  if (!setSelected) return;
  if (!grouping_key) {
    const self_key = getSelfKey(item);
    if (!self_key) return;
    setSelected(selected?.[self_key]?.some((value) => String(value) === self_key) ? undefined : { [self_key]: [self_key] });
    return;
  }
  const group = item?.[grouping_key];
  if (group === undefined) return;

  const next = Object.fromEntries(
    Object.entries(selected || {}).map(([key, values]) => [key, values.map((value) => String(value))]),
  );
  const list = next[grouping_key] || [];
  const nextList = list.some((value) => value === String(group))
    ? list.filter((value) => value !== String(group))
    : [...list, String(group)];

  if (nextList.length) next[grouping_key] = nextList;
  else delete next[grouping_key];

  setSelected(Object.keys(next).length ? next : undefined);
};
